import cx from 'classnames'

import BottomProgramMenu from './components/BottomProgramMenu/BottomProgramMenu'
import HeaderContent from './components/HeaderContent/HeaderContent'
import HeaderMainBar from './components/HeaderMainBar/HeaderMainBar'
import { useBlueHeader } from './hooks/useBlueHeader'
import { useShowHeader } from './hooks/useShowHeader'

import hocHeader from './hocHeader'

import useGtmLoginInfo from 'services/gtm/useGtmLoginInfo'
import './Header.scss'

const Header = ({
    isAuthorized,
    tickets,
    openedChooseCinema,
    openedMenu,
    toggleChooseCineama,
    toggleMenu,
    handleClickProgram,
    basketValidity,
    basketRelease,
    cinemaid,
    chosenCinema,
}) => {
    const { isVisible } = useShowHeader(openedChooseCinema || openedMenu)
    const { isBlue } = useBlueHeader(openedChooseCinema || openedMenu)

    useGtmLoginInfo()

    return (
        <>
            <header className={cx('header', !isVisible && 'header--hide', isBlue && isVisible && 'header--blue')}>
                <HeaderMainBar
                    isAuthorized={isAuthorized}
                    tickets={tickets}
                    basketValidity={basketValidity}
                    openedChooseCinema={openedChooseCinema}
                    onCinema={toggleChooseCineama}
                    onMenu={toggleMenu}
                    basketRelease={basketRelease}
                    chosenCinema={chosenCinema}
                />
                <HeaderContent openedChooseCinema={openedChooseCinema} openedMenu={openedMenu} cinemaid={cinemaid} />
            </header>
            <BottomProgramMenu
                openedMenu={openedMenu}
                programHandleClick={handleClickProgram}
                menuHandleClick={toggleMenu}
            />
        </>
    )
}

export default hocHeader(Header)
